import cn from 'classnames';
import { nanoid } from 'nanoid';
import type { ITooltip, PlacesType } from 'react-tooltip';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { Info } from '@webapp/common/assets/icons';
import { stopEvent } from '@webapp/common/lib/ui';

import css from './tooltip.css';

export interface ITooltipProps extends ITooltip {
    withTooltipIcon?: boolean;
    preventIconClick?: boolean;
    iconClassName?: string;
}

export const Tooltip: FC<ITooltipProps> = ({
    withTooltipIcon,
    preventIconClick,
    variant,
    className,
    iconClassName,
    style,
    ...props
}) => {
    const commonProps = {
        ...props,
        variant: variant || 'light',
        className: cn(css.tooltip, className),
        style: {
            fontSize: 'var(--t-level5_5)',
            ...(style || {}),
        },
    };

    if (withTooltipIcon) {
        const uuid = nanoid();

        const onIconClick = (e) => {
            if (preventIconClick) {
                stopEvent(e);
            }
        };

        return (
            <>
                <Info className={cn(css.icon, iconClassName)} data-tooltip-id={uuid} onClick={onIconClick} />
                <ReactTooltip id={uuid} {...commonProps} />
            </>
        );
    }

    return <ReactTooltip {...commonProps} />;
};

export type { PlacesType as TooltipPlacesType };
